import React from 'react';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ChevronDownRegularIcon(props) {
  return <FontAwesomeIcon icon={faChevronDown} {...props} />;
}
